import React from "react";
import withLoadable from "../components/with-loadable";
import { useRoutes } from "react-router-dom";
import PublicLayout from "../layouts/PublicLayout";
import PrivateLayout from "../layouts/PrivateLayout";
import DashboardLayout from "../layouts/DashboardLayout";
import { Helmet } from "react-helmet";
import { getUserPermissions, hasPermissionForModule, isAdmin } from "../common/LocalStorageService";
// import CourseReviews from "../pages/task/reviews";
import { Notification } from "../pages/notification";
import { AddNotification } from "../pages/notification/add";
import ComplaintFeedback from "../pages/ComplaintFeedback";
// import TrainingReport from "../pages/report/trainingReport/trainingReport";
// import ViewReport from "../pages/report/trainingReport/viewReport";
// import TrainerReviews from "../pages/report/instructorReport/trainersReview";
import Trainers from "../pages/report/instructorReport/trainers";
// import UserActivityReport from "../pages/report/userActivityReport/userActivityReport";
// import ViewUserReport from "../pages/report/userActivityReport/viewUserReport";
import CourseWiseEarnings from "../pages/report/financialReport/courseWiseEarnings";
// import FinancialReport from "../pages/report/financialReport/financialReport";
// import CourseWiseCertificates from "../pages/report/certificationTracking/courseWiseCertificates";
// import ViewCertification from "../pages/report/certificationTracking/viewCertification";

const PageNotFound = withLoadable(() => import("../pages/error/page404"));
const AccessDenied = withLoadable(() => import("../pages/error/page403"));
const DashboardPage = withLoadable(() => import("../pages/Dashboard"));
const LoginPage = withLoadable(() => import("../pages/Login"));
const ForgetPassword = withLoadable(() => import("../pages/password/forgetPassword"));
const OtpVerification = withLoadable(() => import("../pages/password/otpVerification"));
const SetPassword = withLoadable(() => import("../pages/password/createPassword"));
const User = withLoadable(() => import("../pages/User"));
const AddUser = withLoadable(() => import("../pages/User/addUser"));
const UpdateUser = withLoadable(() => import("../pages/User/updateUser"));
const ViewUser = withLoadable(() => import("../pages/User/userView"));

const Trainer = withLoadable(() => import("../pages/trainer"));
const UpdateTrainer = withLoadable(() => import("../pages/trainer/updateTrainer"));
const AddTrainer = withLoadable(() => import("../pages/trainer/addTrainer"));
const ViewTrainer = withLoadable(() => import("../pages/trainer/viewtrainer"));

const FamilyMember = withLoadable(() => import("../pages/familyMember"));
const AddFamilyMember = withLoadable(() => import("../pages/familyMember/addUser"));
const UpdateFamilyMember = withLoadable(() => import("../pages/familyMember/updateUser"));
const ViewFamilyMember = withLoadable(() => import("../pages/familyMember/userView"));

const Category = withLoadable(() => import("../pages/category"));
const SubCategory = withLoadable(() => import("../pages/subcategory"));
const SubCategoryView = withLoadable(() => import("../pages/subcategory/view"));

const Subscription = withLoadable(() => import("../pages/subscription"));
const Subscriptionview = withLoadable(() => import("../pages/subscription/view"));
const Earning = withLoadable(() => import("../pages/earning"));
const ContactUsInquiry = withLoadable(() => import("../pages/contactus"));
  
const CategoryView = withLoadable(() => import("../pages/category/view"));
const Task = withLoadable(() => import("../pages/task"));
const ViewTask = withLoadable(() => import("../pages/task/view"));

// const AddCourse = withLoadable(() => import("../pages/task/add"));
// const UpdateCourse = withLoadable(() => import("../pages/task/update"));

// const EnrollCourseUser = withLoadable(() => import("../pages/task/enrollUsers"));
// const CourseReview = withLoadable(() => import("../pages/review_rating/course"));

const Discount = withLoadable(() => import("../pages/discount"));
const DiscountView = withLoadable(() => import("../pages/discount/view"));
const DiscountUsage = withLoadable(() => import("../pages/discount/usage"));
// const CorporateProfile = withLoadable(() => import("../pages/corporateProfile"));
// const CorporateProfileView = withLoadable(() => import("../pages/corporateProfile/view"));
const Subadmin = withLoadable(() => import("../pages/subadmin"));
const SubadminView = withLoadable(() => import("../pages/subadmin/view"));
const Language = withLoadable(() => import("../pages/language"));
const CommunityForum = withLoadable(() => import("../pages/communityForum"));
const CommunityForumView = withLoadable(() => import("../pages/communityForum/view"));
const Blog = withLoadable(() => import("../pages/blogs"));
const BlogView = withLoadable(() => import("../pages/blogs/view"));
const AnimatedVideo = withLoadable(() => import("../pages/animatedVideo"));
const PrivacyPolicy = withLoadable(() => import("../pages/cms/privacyPolicy"));
const TermsCondition = withLoadable(() => import("../pages/cms/termCondition"));
const AboutUs = withLoadable(() => import("../pages/cms/aboutUs"));
const ContactUs = withLoadable(() => import("../pages/cms/contactUs"));
const FAQ = withLoadable(() => import("../pages/cms/faq"));
const Chat = withLoadable(() => import("../pages/chat"));

const RouterContainer = () => {
  const routes = [
    {
      path: "/",
      element: <PublicLayout />,
      children: [
        {
          path: "/",
          element: <LoginPage />,
        },
        {
          path: "/forget-password",
          element: <ForgetPassword />,
        },
        {
          path: "/otp-verification",
          element: <OtpVerification />,
        },
        {
          path: "/set-password",
          element: <SetPassword />,
        },
        {
          path: "*",
          element: <PageNotFound />,
        },
      ],
    },
    {
      path: "/",
      element: <PrivateLayout />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            // {
            //   path: "*",
            //   element: <AccessDenied />,
            //   access: true
            // },
            {
              path: "/dashboard",
              element: <DashboardPage />,
              access: true
            },
            {
              path: "/users",
              element: <User />,
              access: (hasPermissionForModule("user") && getUserPermissions("user").is_view) || isAdmin()
            },
            {
              path: "/users/add-user",
              element: <AddUser />,
              access: (hasPermissionForModule("user") && getUserPermissions("user").is_view) || isAdmin()
            },
            {
              path: "/users/edit-user",
              element: <UpdateUser />,
              access: (hasPermissionForModule("user") && getUserPermissions("user").is_view) || isAdmin()
            },
            {
              path: "/users/view",
              element: <ViewUser />,
              access: (hasPermissionForModule("user") && getUserPermissions("user").is_view) || isAdmin()
            },
    {
              path: "/subscription",
              element: <Subscription />,
              access: (hasPermissionForModule("subscription") && getUserPermissions("subscription").is_view) || isAdmin()
            },
            {
              path: "/subscription/view",
              element: <Subscriptionview />,
              access: (hasPermissionForModule("subscription") && getUserPermissions("subscription").is_view) || isAdmin()
            },
            {
              path: "/earning",
              element: <Earning />,
              access: (hasPermissionForModule("earning") && getUserPermissions("earning").is_view) || isAdmin()
            },
            {
              path: "/contactus",
              element: <ContactUsInquiry />,
              access: (hasPermissionForModule("contactus") && getUserPermissions("contactus").is_view) || isAdmin()
            },
            
              {
              path: "/familyMember",
              element: <FamilyMember  />,
              access: (hasPermissionForModule("user") && getUserPermissions("user").is_view) || isAdmin()
            },
            {
              path: "/familyMember/add-user",
              element: <AddFamilyMember  />,
              access: (hasPermissionForModule("user") && getUserPermissions("user").is_view) || isAdmin()
            },
            {
              path: "/familyMember/edit-user",
              element: <UpdateFamilyMember  />,
              access: (hasPermissionForModule("user") && getUserPermissions("user").is_view) || isAdmin()
            },
            {
              path: "/familyMember/view",
              element: <ViewFamilyMember />,
              access: (hasPermissionForModule("user") && getUserPermissions("user").is_view) || isAdmin()
            },

            {
              path: "/trainer",
              element: <Trainer />,
              access: (hasPermissionForModule("trainer") && getUserPermissions("trainer").is_view) || isAdmin()
            },
            {
              path: "/trainer/edit",
              element: <UpdateTrainer />,
              access: (hasPermissionForModule("trainer") && getUserPermissions("trainer").is_view) || isAdmin()
            },
            {
              path: "/trainer/add",
              element: <AddTrainer />,
              access: (hasPermissionForModule("trainer") && getUserPermissions("trainer").is_view) || isAdmin()
            },
            {
              path: "/trainer/view",
              element: <ViewTrainer />,
              access: (hasPermissionForModule("trainer") && getUserPermissions("trainer").is_view) || isAdmin()
            },
            {
              path: "/category",
              element: <Category />,
              access: (hasPermissionForModule("category") && getUserPermissions("category").is_view) || isAdmin()
            },
            {
              path: "/category/view",
              element: <CategoryView />,
              access: (hasPermissionForModule("category") && getUserPermissions("category").is_view) || isAdmin()
            },
             {
              path: "/subcategory",
              element: <SubCategory />,
              access: (hasPermissionForModule("category") && getUserPermissions("category").is_view) || isAdmin()
            },
             {
              path: "/subcategory/view",
              element: <SubCategoryView />,
              access: (hasPermissionForModule("category") && getUserPermissions("category").is_view) || isAdmin()
            },
            {
              path: "/task",
              element: <Task />,
              access: (hasPermissionForModule("task") && getUserPermissions("task").is_view) || isAdmin()
            },
             {
                path: "/task/view",
                element: <ViewTask/>,
                access: (hasPermissionForModule("view_task") && getUserPermissions("view_task").is_view) || isAdmin()
              },
            // {
            //   path: "/course/add",
            //   element: <AddCourse />,
            //   access: (hasPermissionForModule("course") && getUserPermissions("course").is_view) || isAdmin()
            // },
            // {
            //   path: "/course/edit",
            //   element: <UpdateCourse />,
            //   access: (hasPermissionForModule("course") && getUserPermissions("course").is_view) || isAdmin()
            // },
             
            // {
            //   path: "/course/enroll-users",
            //   element: <EnrollCourseUser />,
            //   access: (hasPermissionForModule("course") && getUserPermissions("course").is_view) || isAdmin()
            // },
            // {
            //   path: "/course/reviews",
            //   element: <CourseReviews />,
            //   access: (hasPermissionForModule("course") && getUserPermissions("course").is_view) || isAdmin()
            // },
            // {
            //   path: "/review/course",
            //   element: <CourseReview />,
            //   access: (hasPermissionForModule("review") && getUserPermissions("review").is_view) || isAdmin()
            // },
            {
              path: "/discount",
              element: <Discount />,
              access: (hasPermissionForModule("discount code") && getUserPermissions("discount code").is_view) || isAdmin()
            },
            {
              path: "/discount/view",
              element: <DiscountView />,
              access: (hasPermissionForModule("discount code") && getUserPermissions("discount code").is_view) || isAdmin()
            },
            {
              path: "/discount/usage",
              element: <DiscountUsage />,
              access: (hasPermissionForModule("discount code") && getUserPermissions("discount code").is_view) || isAdmin()
            },
            // {
            //   path: "/corporate-profile",
            //   element: <CorporateProfile />,
            //   access: (hasPermissionForModule("corporate profile") && getUserPermissions("corporate profile").is_view) || isAdmin()
            // },
            // {
            //   path: "/corporate-profile/view",
            //   element: <CorporateProfileView />,
            //   access: (hasPermissionForModule("corporate profile") && getUserPermissions("corporate profile").is_view) || isAdmin()
            // },
            {
              path: "/subadmin",
              element: <Subadmin />,
              access: (hasPermissionForModule("subadmin") && getUserPermissions("subadmin").is_view) || isAdmin()
            },
            {
              path: "/subadmin/view",
              element: <SubadminView />,
              access: (hasPermissionForModule("subadmin") && getUserPermissions("subadmin").is_view) || isAdmin()
            },
            {
              path: "/language",
              element: <Language />,
              access: (hasPermissionForModule("language") && getUserPermissions("language").is_view) || isAdmin()
            },
            {
              path: "/community-forum",
              element: <CommunityForum />,
              access: (hasPermissionForModule("community forum") && getUserPermissions("community forum").is_view) || isAdmin()
            },
            {
              path: "/community-forum/view",
              element: <CommunityForumView />,
              access: (hasPermissionForModule("community forum") && getUserPermissions("community forum").is_view) || isAdmin()
            },
            {
              path: "/blog",
              element: <Blog />,
              access: (hasPermissionForModule("blog") && getUserPermissions("blog").is_view) || isAdmin()
            },
            {
              path: "/blog/view",
              element: <BlogView />,
              access: (hasPermissionForModule("blog") && getUserPermissions("blog").is_view) || isAdmin()
            },
            {
              path: "/animated-video",
              element: <AnimatedVideo />,
              access: (hasPermissionForModule("animated video") && getUserPermissions("animated video").is_view) || isAdmin()
            },
            {
              path: "/complaint-feedback",
              element: <ComplaintFeedback />,
              access: true
            },
            {
              path: "/privacy-policy",
              element: <PrivacyPolicy />,
              access: (hasPermissionForModule("cms") && getUserPermissions("cms").is_view) || isAdmin()
            },
            {
              path: "/about",
              element: <AboutUs />,
              access: (hasPermissionForModule("cms") && getUserPermissions("cms").is_view) || isAdmin()
            },
            {
              path: "/terms-condition",
              element: <TermsCondition />,
              access: (hasPermissionForModule("cms") && getUserPermissions("cms").is_view) || isAdmin()
            },
            {
              path: "/contact-us",
              element: <ContactUs />,
              access: (hasPermissionForModule("cms") && getUserPermissions("cms").is_view) || isAdmin()
            },
            {
              path: "/faq",
              element: <FAQ />,
              access: (hasPermissionForModule("cms") && getUserPermissions("cms").is_view) || isAdmin()
            },
            {
              path: "/chat",
              element: <Chat />,
              access: (hasPermissionForModule("chat") && getUserPermissions("chat").is_view) || isAdmin()
            },
            {
              path: "/notification",
              element: <Notification />,
              access: true
            },
            {
              path: "/notification/add",
              element: <AddNotification />,
              access: true
            },
            // {
            //   path: "/training-report",
            //   element: <TrainingReport />,
            //   access: true
            // },
            // {
            //   path: "/training-report/view",
            //   element: <ViewReport />,
            //   access: true
            // },
            {
              path: "/instructor-report",
              element: <Trainers />,
              access: true
            },
            // {
            //   path: "/instructor-report/view",
            //   element: <TrainerReviews />,
            //   access: true
            // },
            // {
            //   path: "/user-report",
            //   element: <UserActivityReport />,
            //   access: true
            // },
            // {
            //   path: "/user-report/view",
            //   element: <ViewUserReport />,
            //   access: true
            // },
            {
              path: "/course-earnings",
              element: <CourseWiseEarnings />,
              access: true
            },
            // {
            //   path: "/course-earnings/view",
            //   element: <FinancialReport />,
            //   access: true
            // },
            // {
            //   path: "/certification-report",
            //   element: <CourseWiseCertificates />,
            //   access: true
            // },
            // {
            //   path: "/certification-report/view",
            //   element: <ViewCertification />,
            //   access: true
            // }
          ].filter((item) => item.access),
        },
      ],

    },
  ];

  return (
    <>
      <Helmet>
        <script
          src={process.env.PUBLIC_URL + "/assets/js/app.js"}
          async
        ></script>
      </Helmet>
      {useRoutes(routes)}
    </>
  );
};

export default RouterContainer;
